// Generated by Claude Code

/** A freshly issued client id + secret pair; the secret is only ever returned once. */
export default class ApiUserSecret {
  identifier: string = ''
  secret: string = ''
}
